const moneyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

/**
 * Collection of money formatters.
 */
export const moneyFormatters = {
  /**
   * Default money formatter.
   */
  default: moneyFormatter,
}
